module.exports = __webpack_public_path__ + "static/cal_hacks_4-5904ea53bd260b26803fd2d9d1bfe03e.png";